export const FILTERS_UPDATED = 'FILTERS_UPDATED';
export const PRICE_RANGE_UPDATED = 'PRICE_RANGE_UPDATED';
export const SQUARE_FEET_UPDATED = 'SQUARE_FEET_UPDATED';
export const BEDS_BATHS_UPDATED = 'BEDS_BATHS_UPDATED';
export const BRAND_UPDATED = 'BRAND_UPDATED';
export const HOME_TYPES_UPDATED = 'HOME_TYPES_UPDATED';
export const BAYS_UPDATED = 'BAYS_UPDATED';
export const FLOORS_UPDATED = 'FLOORS_UPDATED';
export const QUICK_MOVE_IN_UPDATED = 'QUICK_MOVE_IN_UPDATED';
export const MPC_ONLY_UPDATED = 'MPC_ONLY_UPDATED';
export const RESET_CLICKED = 'RESET_CLICKED';
export const DI_UPDATED = 'DI_UPDATED';
export const SORT_BY_UPDATED = 'SORT_BY_UPDATED';
export const ASC_UPDATED = 'ASC_UPDATED';

const resetClicked = () => {
  return (dispatch) => {
    dispatch({
      type: RESET_CLICKED
    });
  };
};

const diUpdated = (di) => {
  return (dispatch) => {
    dispatch({
      type: DI_UPDATED,
      di
    });
  };
};

const filtersUpdated = () => {
  return (dispatch) => {
    dispatch({
      type: FILTERS_UPDATED
    });
  };
};

const priceRangeUpdated = (minPrice, maxPrice) => {
  return (dispatch) => {
    dispatch({
      type: PRICE_RANGE_UPDATED,
      minPrice: Number(minPrice),
      maxPrice: Number(maxPrice)
    });
  };
};

const squareFeetUpdated = (minSquareFeet, maxSquareFeet) => {
  return (dispatch) => {
    dispatch({
      type: SQUARE_FEET_UPDATED,
      minSquareFeet,
      maxSquareFeet
    });
  };
};

const brandUpdated = (brand) => {
  return (dispatch) => {
    dispatch({
      type: BRAND_UPDATED,
      brand
    });
  };
};

const bedBathsUpdated = (beds, baths) => {
  return (dispatch) => {
    dispatch({
      type: BEDS_BATHS_UPDATED,
      beds,
      baths
    });
  };
};

const homeTypesUpdated = (homeTypes) => {
  return (dispatch) => {
    dispatch({
      type: HOME_TYPES_UPDATED,
      homeTypes
    });
  };
};

const baysUpdated = (bays) => {
  return (dispatch) => {
    dispatch({
      type: BAYS_UPDATED,
      bays
    });
  };
};

const floorsUpdated = (floors) => {
  return (dispatch) => {
    dispatch({
      type: FLOORS_UPDATED,
      floors
    });
  };
};

const quickMoveInUpdated = (quickMoveIn) => {
  return (dispatch) => {
    dispatch({
      type: QUICK_MOVE_IN_UPDATED,
      quickMoveIn
    });
  };
};

const mpcOnlyUpdated = (mpcOnly) => {
  return (dispatch) => {
    dispatch({
      type: MPC_ONLY_UPDATED,
      mpcOnly
    });
  };
};

const sortByUpdated = (sortBy) => {
  return (dispatch) => {
    dispatch({
      type: SORT_BY_UPDATED,
      sortBy
    });
  };
};

const ascUpdated = (asc) => {
  return (dispatch) => {
    dispatch({
      type: ASC_UPDATED,
      asc
    });
  };
};

export {
  filtersUpdated,
  priceRangeUpdated,
  squareFeetUpdated,
  brandUpdated,
  bedBathsUpdated,
  homeTypesUpdated,
  baysUpdated,
  floorsUpdated,
  quickMoveInUpdated,
  mpcOnlyUpdated,
  resetClicked,
  diUpdated,
  sortByUpdated,
  ascUpdated
};
